import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Target, Trophy, Users } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
export function BenefitsSection() {
  return <section className="relative py-20 px-4 overflow-hidden" data-id="element-443">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-444">
        <img src="https://cdn.magicpatterns.com/uploads/wWkUz6j9bevKUxChdJV2SU/493952978_1236854048448641_3820169927173941526_n.jpg" alt="NWBBA Students" className="w-full h-full object-cover object-top" data-id="element-445" />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-[#0f1f3d]/90" data-id="element-446"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-447">
        <div className="text-center mb-16" data-id="element-448">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-449">
            More Than Just Kicks & Punches
          </h2>
          <div className="w-24 h-1 bg-[#a3d977] mx-auto rounded-full mb-4" data-id="element-450"></div>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-451">
            We don't just teach self-defense. We teach character development
            that lasts a lifetime.
          </p>
        </div>

        <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-452">
          {[{
          icon: Trophy,
          title: 'Unshakable Confidence',
          desc: 'Kids learn to believe in themselves, speak up, and stand tall in any situation.'
        }, {
          icon: Target,
          title: 'Laser Focus',
          desc: 'Improved concentration that translates directly to better grades and behavior.'
        }, {
          icon: ShieldCheck,
          title: 'Discipline & Respect',
          desc: 'Learning to listen, follow directions, and respect authority figures.'
        }, {
          icon: Users,
          title: 'Positive Community',
          desc: 'Surrounded by supportive mentors and friends who encourage growth.'
        }].map((benefit, idx) => <motion.div key={idx} variants={fadeIn} className="flex gap-4 items-start p-6 rounded-xl border-2 border-[#a3d977]/20 bg-white/10 backdrop-blur-sm" data-id="element-453">
              <div className="bg-[#1e3a8a] p-3 rounded-lg shrink-0 border-2 border-[#a3d977]/30" data-id="element-454">
                <benefit.icon className="w-6 h-6 text-[#a3d977]" data-id="element-455" />
              </div>
              <div data-id="element-456">
                <h3 className="text-xl font-bold mb-2 text-white" data-id="element-457">
                  {benefit.title}
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-458">{benefit.desc}</p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}